import { atom } from "recoil";

export const getDataCFIT = atom({
  key: "getDataCFIT",
  default: [],
});
